export default function () {
  let discountsActive = [];

  /**
   * Set the cursor style for the body element
   * @param {string} cursorStyle - the CSS cursor style to set (e.g., 'wait', 'default')
   */
  function setCursor(cursorStyle) {
    $('body').css('cursor', cursorStyle);
  }

  /**
   * Check if a coupon code is currently active
   * @param {string} couponcode
   * @returns {boolean}
   */
  function isCouponActive(couponcode) {
    const normalizedCode = couponcode.toUpperCase();
    return discountsActive.some((d) => d.code.toUpperCase() === normalizedCode);
  }

  /**
   * Set a Coupon-Checkbox to checked and disabled
   * @param {string} couponcode
   */
  function checkCouponActivation(couponcode) {
    const normalizedCode = couponcode.toUpperCase();
    const couponClass = '._coupon_activation_' + normalizedCode;
    const $checkbox = $(couponClass);

    console.log(`show active coupon: ${couponClass}`);

    $checkbox.prop('checked', true);
    //$checkbox.prop('disabled', true);
    $checkbox.parent().addClass('coupon-checkbox--is-active');

    // in checkout it should be shown - not activate in checkout
    $(couponClass).show();
  }

  /**
   * Set a Coupon-Checkbox to unchecked and enabled
   * (if activation failed)
   * @param {string} couponcode
   */
  function uncheckCouponActivation(couponcode) {
    const normalizedCode = couponcode.toUpperCase();
    console.log(`un-show active coupon: ._coupon_activation_${normalizedCode}`);

    const $checkbox = $('._coupon_activation_' + normalizedCode);
    $checkbox.prop('checked', false);
    //$checkbox.prop('disabled', false);
    $checkbox.parent().removeClass('coupon-checkbox--is-active');
  }

  /**
   * Hide inactive coupons checkboxes
   * Currently only used on the checkout page
   * @param {Array} discountsActive
   */
  function hideInactiveCoupons(discountsActive) {
    const activeCodeClasses = discountsActive.map((d) => '_coupon_activation_' + d.code.toUpperCase());

    $('._coupon_activation').each(function () {
      const $checkbox = $(this);
      const isActive = activeCodeClasses.some((codeClass) => $checkbox.hasClass(codeClass));

      if (!isActive) {
        $checkbox.parents('.coupon-activation-banner').hide();
      }
    });
  }

  /**
   * Send a coupon code for activation
   * @param {string} couponcode
   */
  function activateCoupon(couponcode) {
    const normalizedCode = couponcode.toUpperCase();
    console.log(`try to activate coupon: ${normalizedCode}`);

    $.ajax({
      url: '/rpc.php?action=addcode',
      method: 'POST',
      data: { voucher: normalizedCode },
      success: function (response) {
        console.log(`activation success: ${normalizedCode}`);

        if (response?.success === 1) {
          // Erfolg
          if (!isCouponActive(normalizedCode)) {
            discountsActive.push({ code: normalizedCode });
            console.log('added to active discounts:', normalizedCode);
          }
        } else {
          // Fehler oder unbekannter Zustand
          console.warn(`activation not successful: ${normalizedCode}`);
          uncheckCouponActivation(normalizedCode);
        }
      },
      error: function (xhr, status, error) {
        console.warn(`activation failed: ${normalizedCode}`);
        console.log('Fehler beim Request:', error);
        uncheckCouponActivation(normalizedCode);
      },
      complete: function (xhr, status) {
        console.log('AJAX complete');
        console.log('Status:', status);
        console.log('Response:', xhr.responseText);

        if (window.location.pathname === '/warenkorb/' || window.location.pathname === '/warenkorb.html') {
          // at page url basket/cart we need a reload to show recalculated the values
          window.location.replace(window.location.pathname + window.location.search);
        }
      },
    });
  }

  /**
   * Send a coupon code for removal
   * @param {string} couponcode
   * @param {boolean} refreshpage - whether to reload the page after removal
   */
  function removeCoupon(couponcode, refreshpage = false, coupontype = 'coupon') {
    setCursor('wait');

    console.log(`try to remove coupontype ${coupontype}: ${couponcode}`);

    $.ajax({
      url: `/rpc.php?action=removefrombasket&${coupontype}=${couponcode}`,
      method: 'GET',
      success: function (response) {
        console.log(`removal success: ${couponcode}`);
        uncheckCouponActivation(couponcode);

        const normalizedCode = couponcode.toUpperCase();
        discountsActive = discountsActive.filter((d) => d.code.toUpperCase() !== normalizedCode);
        console.log('removed from active discounts:', normalizedCode);
      },
      error: function (xhr, status, error) {
        console.warn(`removal failed: ${couponcode}`);
        console.log('Fehler beim Request:', error);
      },
      complete: function (xhr, status) {
        console.log('AJAX complete');
        console.log('Status:', status);
        console.log('Response:', xhr.responseText);

        setCursor('default');
        if (
          refreshpage ||
          window.location.pathname === '/warenkorb/' ||
          window.location.pathname === '/warenkorb.html'
        ) {
          // at page url basket/cart we need a reload to show recalculated the values
          window.location.reload(true);
        }
      },
    });
  }

  /**
   * Handler for coupon activation change events
   */
  function handleCouponChange() {
    const code = this.value;

    if (this.checked) {
      console.log('aktiviert:', code);
      checkCouponActivation(code);
      activateCoupon(code);
    } else {
      console.log('deaktiviert:', code);
      removeCoupon(code);
    }
  }

  /**
   * Attach change event listener to coupon activation sliders
   */
  function setupCouponChangeListeners() {
    $('._coupon_activation').on('change', handleCouponChange);
  }

  /**
   * Setup MutationObserver to watch for dynamically loaded product list elements
   */
  function setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-loaded' &&
          mutation.target.classList.contains('productlist-combi_element')
        ) {
          const $element = $(mutation.target);

          if ($element.attr('data-loaded') === 'true') {
            $element.find('._coupon_activation').on('change', handleCouponChange);
            $element.find('._coupon_activation').each(function () {
              const code = $(this).val();
              if (code && isCouponActive(code)) {
                checkCouponActivation(code);
              }
            });
          }
        }
      });
    });

    const productListElements = document.querySelectorAll('.productlist-combi_element');
    const observerConfig = {
      attributes: true,
      attributeFilter: ['data-loaded'],
      subtree: false,
    };

    productListElements.forEach((element) => {
      observer.observe(element, observerConfig);
    });

    console.log(`Observing ${productListElements.length} product list elements for changes`);
  }

  /**
   * Initialize the coupon module by checking active discounts and setting up event listeners
   */
  function init() {
    discountsActive = window.dataLayer?.[0]?.['discounts'] || [];

    if (discountsActive) {
      console.log('active discounts:', discountsActive);

      discountsActive.forEach((discountActive, index) => {
        console.log(index, discountActive);
        checkCouponActivation(discountActive.code);
      });

      const isCheckout = window.location.pathname === '/checkout/3/'; // checkout payment
      const isPaypalCheckout = window.location.pathname === '/expresscheckout/'; // one-page express checkout
      const isCardCheckout = window.location.pathname === '/checkout/'; // checkout error-cart
      if (isCheckout || isPaypalCheckout || isCardCheckout) {
        hideInactiveCoupons(discountsActive);
      }
    } else {
      console.log('active discounts: keine');
    }

    setupCouponChangeListeners();
    setupMutationObserver();

    $(document).on('click', '._cart-coupon-remove', function () {
      const $button = $(this);
      const couponCode = $button.data('removeitem');
      const couponType = couponCode.includes('€') ? 'coupon_apocash' : 'coupon';
      const refreshpage = $button.data('refreshpage');

      if (!couponCode) {
        console.error('No coupon code found in data-removeitem attribute');
        return false;
      }

      $button.closest('._cart-coupon').hide(400);
      removeCoupon(couponCode, refreshpage == 1, couponType);

      return false;
    });
  }

  init();
}
